module.exports = __webpack_public_path__ + "static/media/report_keep.393f9337.svg";